module.exports = __webpack_public_path__ + "assets/img/package-woman-old.f0b602b7.svg";